import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import { ImagePreview } from "../../posts/Photos/PhotoUploader";
// import {productCategoryAssociationsStore} from "../productCategoryAssociations/productCategoryAssociationsStore";
import { 
// timeSince,
useXS } from 'common-frontend-components';
import { postCardMobileStyle, postCardStyle } from "../../../../assets/styles/styles";
import { textColor } from "../../../../assets/styles/colors";
// import {CategoryChip} from "../categories/CategoryChip";
// import {wwwLinks} from "../../variables/wwwRoutes";
// import {ProductLinks} from "./ProductLinks";
// import {searchAndFilterDialogStore} from "../popups/SearchAndFilter";
// import {categoriesStore} from "../categories/useCategoriesStore";
import { productPhotosStore } from "../../../../stores/products/productPhotosStore";
import { productIconsStore } from "../../../../stores/products/productIconsStore";
import { ShowPrices } from "./ShowPrice";
import { productsFullViewStore } from "../../../../stores/products/productsFullViewStore";
export const WwwProductCard = ({ product, width = 190, titleProps = {} }) => {
    const photos = productPhotosStore.usePhotosByProductId(product.id);
    const icons = productIconsStore.useIconsByProductId(product.id);
    // const productCategoryAssociations = productCategoryAssociationsStore.useProductCategoryAssociations();
    // const categories = useMemo(()=>productCategoryAssociationsStore.getProductCategories(product.id), [productCategoryAssociations]);
    const isMobile = useXS();
    const onClick = (e) => {
        e.stopPropagation();
        productsFullViewStore.openFullView({ photos: photos || [], index: 0 });
    };
    return (_jsx(Box, { sx: { width, cursor: 'pointer' }, onClick: onClick, children: _jsxs(Card, { variant: "outlined", sx: { ...(isMobile ? postCardMobileStyle : postCardStyle), background: 'transparent', boxShadow: 'none', padding: 0 }, children: [_jsx(Typography, { color: "text.secondary", gutterBottom: true, ...titleProps, sx: {
                        fontSize: '1.1rem',
                        fontWeight: 400,
                        paddingBottom: 1,
                        color: textColor,
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        ...(titleProps.sx || {})
                    }, children: product.title }, void 0), _jsxs(Grid, { container: true, spacing: 1, children: [icons &&
                            _jsx(Grid, { item: true, children: _jsx(ImagePreview, { photos: photos || [], index: 0, icons: icons, onClick: onClick }, void 0) }, void 0), (product.price || product.sale) ?
                            _jsx(Grid, { item: true, xs: 12, children: _jsx(ShowPrices, { product: product, untilMsg: false, onClick: onClick }, void 0) }, void 0) : null] }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=WwwProductCard.js.map